// constants
import { showSuccessAlert } from "../../constants/alerts";
import { SubCourseActionTypes } from "./constants";

const INIT_STATE = {
  subcourses: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface SubcourseData {
  id: number;
  name: string;
  courseId: string;
}

interface CourseActionType {
  type:
    | SubCourseActionTypes.API_RESPONSE_SUCCESS
    | SubCourseActionTypes.API_RESPONSE_ERROR
    | SubCourseActionTypes.CREATE_SUB_COURSE
    | SubCourseActionTypes.UPDATE_SUB_COURSE
    | SubCourseActionTypes.GET_SUB_COURSE
    | SubCourseActionTypes.DELETE_SUB_COURSE;
  payload: {
    actionType?: string;
    data?: SubcourseData | {};
    error?: string;
    subcourses?: [];
  };
}

interface State {
  subcourses?: SubcourseData[] | [];
  loading?: boolean;
  value?: boolean;
}

const SubCourseStates = (
  state: State = INIT_STATE,
  action: CourseActionType
): any => {
  switch (action.type) {
    case SubCourseActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case SubCourseActionTypes.CREATE_SUB_COURSE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case SubCourseActionTypes.GET_SUB_COURSE: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            subcourses: action.payload.data,
          };
        }
        case SubCourseActionTypes.UPDATE_SUB_COURSE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case SubCourseActionTypes.DELETE_SUB_COURSE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case SubCourseActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case SubCourseActionTypes.CREATE_SUB_COURSE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case SubCourseActionTypes.UPDATE_SUB_COURSE: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case SubCourseActionTypes.GET_SUB_COURSE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case SubCourseActionTypes.DELETE_SUB_COURSE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case SubCourseActionTypes.CREATE_SUB_COURSE:
      return { ...state, loading: true };
    case SubCourseActionTypes.UPDATE_SUB_COURSE:
      return { ...state, loading: true };
    case SubCourseActionTypes.GET_SUB_COURSE:
      return { ...state, loading: true, initialLoading: true };
    case SubCourseActionTypes.DELETE_SUB_COURSE:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default SubCourseStates;
